// extracted by mini-css-extract-plugin
module.exports = {"langPanel":"LangPanel_langPanel__3frUw","langButton":"LangPanel_langButton__3ZeRR","langButtonActive":"LangPanel_langButtonActive__3RbNp"};